import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import "./LiveGroupBuyPosterModal.scss";

function LiveGroupBuyPosterModal({ posterUrl, onClose }) {
  return (
    <div className="live-group-buy-poster-mask">
      <div className="live-group-buy-poster-modal">
        <button
          type="button"
          className="live-group-buy-poster-close"
          onClick={onClose}
        >
          <CloseOutlined />
        </button>
        <div className="live-group-buy-poster-title">拼团优惠</div>
        <div className="live-group-buy-poster-subtitle">
          扫码拼团，享优惠！
        </div>
        <div className="live-group-buy-poster-preview">
          <img
            className="live-group-buy-poster-image"
            src={posterUrl}
            alt="拼团海报"
          />
        </div>
        <div className="live-group-buy-poster-actions">
          <button
            type="button"
            className="live-group-buy-poster-close-btn"
            onClick={onClose}
          >
            关闭
          </button>
        </div>
      </div>
    </div>
  );
}

export default LiveGroupBuyPosterModal;
